<script>
import axios from "axios";
import { financialyearComputed, financialyearMethods } from '@/state/helpers';

// axios.defaults.baseURL = "http://127.0.0.1:8000/api";
axios.defaults.baseURL = 'https://admin.tandika.cloud/api';

const token = localStorage.getItem("token");
if (token) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
} else {
  axios.defaults.headers.common["Authorization"] = "";
  axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
}
import appConfig from "@/app.config";
export default {
  name: "app",
  page: {
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    },
  },

  data() {
    return {
      toastShown: false,
      financialYearInitialized: false,
    }
  },
  computed: {
    ...financialyearComputed
  },
  mounted() {
    this.checkForUnauthorization();
    this.checkLicense();
    this.syncFinancialYearState(this.$route);
  },
  watch: {
    $route(to) {
      this.syncFinancialYearState(to);
    },
  },

  methods: {
    ...financialyearMethods,
    isAuthRequiredRoute(route = this.$route) {
      return route && route.matched && route.matched.some((record) => record.meta && record.meta.authRequired);
    },

    async syncFinancialYearState(route) {
      if (!this.isAuthRequiredRoute(route)) {
        this.financialYearInitialized = false;
        return;
      }

      if (this.financialYearInitialized) {
        return;
      }

      this.financialYearInitialized = true;
      await this.fetchFinancialYears();

      const storedFinancialYear = JSON.parse(localStorage.getItem("financialyear"));
      if (storedFinancialYear) {
        await this.$store.dispatch("financialyears/fetchSetFinancialYearData", storedFinancialYear);
      }
    },

    checkLicense() {
      const active_license = localStorage.getItem('active_license')
      if (active_license == 0) {
        this.$router.push('/expired-license');
        if (active_license == 0) {
          this.$router.beforeEach((to, from, next) => {
            next(false);
          });
        }
      }
    },

    handleUnauthorizedError() {
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      this.$router.push('/login');
      this.$toast.warning("Session expired, please login again");
      this.toastShown = true;
      setTimeout(() => {
        this.toastShown = false;
      }, 10000);
    },

    async checkForUnauthorization() {
      await axios.interceptors.response.use(
        response => response,
        error => {
          // Add "error.response &&" to prevent the app from crashing during network/CORS errors
          if (error.response && error.response.status === 401 && !this.toastShown) {
            this.handleUnauthorizedError();
          }
          return Promise.reject(error);
        }
      );
    }
  },
}
</script>

<template>
  <div id="app">
    <RouterView />
  </div>
</template>
